export default __webpack_public_path__ + "static/media/58.43686d33.jpg";